import { render } from "./TopLogo.vue?vue&type=template&id=5cbff164&ts=true"
import script from "./TopLogo.vue?vue&type=script&lang=ts"
export * from "./TopLogo.vue?vue&type=script&lang=ts"

import "./TopLogo.vue?vue&type=style&index=0&id=5cbff164&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__